import { Textarea } from "../ui/textarea";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { UseFormReturn, Path } from "react-hook-form";

export default function FormTextarea<TFieldValues extends Record<string, unknown>>({
  form,
  label,
  id,
  description,
  className,
  itemStyles,
  fieldName,
  itemKey,
}: {
  form: UseFormReturn<TFieldValues>;
  label: string;
  id: Path<TFieldValues>;
  description?: string;
  itemStyles?: string;
  className?: string;
  fieldName?: Path<TFieldValues>;
  itemKey?: string | number;
}) {
  return (
    <FormField
      key={itemKey}
      control={form.control}
      name={fieldName || id}
      render={({ field }) => (
        <FormItem className={itemStyles}>
          <FormLabel>{label}</FormLabel>
          <FormControl>
            <Textarea {...field} value={field.value as string | number | readonly string[] | undefined} className={className} />
          </FormControl>
          <FormDescription>{description}</FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
